// Polyfills
import 'core-js/es/map';
import 'core-js/es/set';
import 'raf/polyfill';

// React
import React from 'react';
import ReactDom from 'react-dom';
import { Provider } from 'react-redux';
import config from './config';

// Sentry 
import * as Sentry from "@sentry/react";

// Redux
import * as Redux from 'redux';
import ReduxThunk from 'redux-thunk';

// GA
import ReactGA from 'react-ga';

// Router
import { Router } from 'react-router';
import { routerReducer } from 'react-router-redux';

// Apollo Client
import { ApolloProvider } from 'react-apollo';

// Reducers
import AuthReducer from './reducer/AuthReducer';
import PhotoReducer from './reducer/PhotoReducer';
import NotificationReducer from './reducer/NotificationReducer';
import UserUIReducer from './reducer/UserUIReducer';
import VideoReducer from './reducer/VideoReducer';
import WebSocketReducer from './reducer/WebSocketReducer';

import App from './container/App';
import AuthTokenManager from './container/Auth/AuthTokenManager';

import NetworkClient from './networkClient';

import registerServiceWorker from './registerServiceWorker';


// CSS
import './lib/css/style.css';
import 'rc-tooltip/assets/bootstrap.css';
import 'react-tiles-dnd/esm/index.css';

// Load Fonts
import './fonts';
import './lib/fonts/Inter-SemiBold';

import { createBrowserHistory as createHistory } from 'history';
import {initAnalytics} from "./common/Analytics";

// Loaded Successfully -- Remove refresh app cache check for next version update
try {
  sessionStorage.removeItem('appRefreshed');
} catch (e) {
  // continue
}

try {
  // Init Analytics
  initAnalytics();

  // Initialize store
  const store = Redux.createStore(
    Redux.combineReducers({
      routing: routerReducer,
      Auth: AuthReducer,
      Photo: PhotoReducer,
      Notifications: NotificationReducer,
      UserUI: UserUIReducer,
      Video: VideoReducer,
      WS: WebSocketReducer,
    }),
    Redux.applyMiddleware(ReduxThunk));

  // Initialize Network Client
  const apolloClient = NetworkClient(store);

  // Create an enhanced history that syncs navigation events with the store
  const history = createHistory();

  // Initialize sentry 
  Sentry.init({
    dsn: config.sentryDSN,
    debug: false,
  });
    
  // Initialize Google Analytics
  ReactGA.initialize(config.gaID);
  ReactGA.set({ anonymizeIp: true });
  history.listen(location => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
  });

  // Handle on click firing for iOS
  if ('ontouchstart' in document.documentElement) {
    document.body.style.cursor = 'pointer';
    document.body.style.webkitTapHighlightColor = 'rgba(0, 0, 0, 0)';
  }

  ReactDom.render(
    <Provider store={store}>
      <ApolloProvider client={apolloClient}>
        <Router history={history}>
          <AuthTokenManager>
            <App />
          </AuthTokenManager>
        </Router>
      </ApolloProvider>
    </Provider>,
    document.getElementById('root'));

  // Service worker cache
  // registerServiceWorker();

  // Remove CookiePro buggy cookies
  document.cookie = `OptanonAlertBoxClosed=; path=/; domain=.set.plastick.rocks; expires=${new Date().toUTCString()}`;
  document.cookie = `OptanonConsent=; path=/; domain=.set.plastick.rocks; expires=${new Date().toUTCString()}`;
} catch (error) {
  ReactDom.render(
    <div style={{ display: 'none' }}>
      {JSON.stringify(error)}
    </div>,
    document.getElementById('root'));
}
